import { PRODUCT_STATUSES, type ProductStatus } from "@packagepage/shared";

export interface ProductSearch {
  readonly status?: ProductStatus;
}

/** `/products?status=draft`. A word outside `PRODUCT_STATUSES` is dropped, like `/recalls/new`'s `product`. */
export function validateProductSearch(search: Record<string, unknown>): ProductSearch {
  const status = PRODUCT_STATUSES.find((s) => s === search["status"]);
  return status === undefined ? {} : { status };
}
